import React, { type PropsWithChildren } from "react";

function Error({ children }: PropsWithChildren) {
  return <div className="py-1 text-red-500 text-sm">{children}</div>;
}

export default Error;
